import { render } from "./InstrumentsMenu2.vue?vue&type=template&id=5a7c3c66&scoped=true"
import script from "./InstrumentsMenu2.vue?vue&type=script&lang=js"
export * from "./InstrumentsMenu2.vue?vue&type=script&lang=js"

import "./InstrumentsMenu2.vue?vue&type=style&index=0&id=5a7c3c66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7c3c66"]])

export default __exports__